// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.addPostCon .el-form-item__label {\n  line-height: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
